import React from "react";
import { cn } from "@/lib/utils";
import type { GuesteriaPartnerRow } from "@/components/pages/guesteria-partners/utils/guesteriaPartnersModel";

type GuesteriaPartnerLogoProps = {
  logo: GuesteriaPartnerRow["logo"];
  variant: "table" | "detail";
  alt?: string;
};

export function GuesteriaPartnerLogo({
  logo,
  variant,
  alt = "",
}: GuesteriaPartnerLogoProps): React.JSX.Element {
  const hasImage = Boolean(logo.imageSrc);

  if (variant === "table") {
    return (
      <div
        className={cn(
          "flex h-[42px] w-[40px] shrink-0 items-center justify-center rounded-lg",
          hasImage
            ? "bg-white p-0.5"
            : `text-sm font-semibold text-white ${logo.className}`,
        )}
      >
        {hasImage ? (
          <img
            src={logo.imageSrc}
            alt={alt}
            className="h-full w-full object-contain"
          />
        ) : (
          logo.letter
        )}
      </div>
    );
  }

  if (hasImage) {
    return (
      <img
        src={logo.imageSrc}
        alt={alt}
        className="h-32 w-32 shrink-0 object-contain"
      />
    );
  }

  return (
    <div
      className={`flex h-32 w-32 shrink-0 items-center justify-center rounded-2xl text-4xl font-semibold text-white shadow-sm ${logo.className}`}
    >
      {logo.letter}
    </div>
  );
}
